import React, { useState, useEffect } from 'react';
import { Table, Tag, message } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import doctorsApi from '../api/doctorsApi';
import moment from 'moment';

const ROLE_MAP = {
  1: { label: 'Admin', color: 'red' },
  2: { label: 'Doctor', color: 'blue' },
  3: { label: 'User', color: 'green' },
  4: { label: 'Manager', color: 'orange' },
  5: { label: 'Operator', color: 'purple' },
  6: { label: 'Operator', color: 'purple' },
  7: { label: 'Medical Center', color: 'cyan' },
};

const DoctorsTab = ({ partnerId }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      const data = await doctorsApi.getPlatformUsers(partnerId, { page });
      setUsers(data.data || []);
      setPagination({
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      });
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [partnerId]);

  const handleTableChange = (pag) => {
    fetchUsers(pag.current);
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (role) => {
        const info = ROLE_MAP[role] || { label: role, color: 'default' };
        return <Tag color={info.color}>{info.label}</Tag>;
      },
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => date ? moment(date).format('DD/MM/YYYY HH:mm') : '-',
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
        <TeamOutlined style={{ fontSize: 20 }} />
        <span style={{ fontSize: 16, fontWeight: 500 }}>
          {pagination.total} user(s) linked to this partner
        </span>
      </div>

      <Table
        columns={columns}
        dataSource={users}
        loading={loading}
        rowKey="id"
        pagination={pagination}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default DoctorsTab;
